import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '';

export interface HomeWidgetResponse {
  tieneEventoActivo: boolean;
  mensaje?: string;
  evento?: {
    idCongreso: number;
    nombre: string;
    lugar: string;
    fechaDesde: string;
    fechaHasta: string;
    imagenBannerUrl?: string;
    avisoAdquisicion: string;
    urlMicrositio: string;
  };
}

export interface GenerarLinkResponse {
  exitoso: boolean;
  mensaje: string;
  token: string;
  urlTransferencia: string;
  fechaExpiracion?: string;
}

export interface InfoLinkTransferencia {
  valido: boolean;
  consumido: boolean;
  mensaje: string;
  token?: string;
  nombreAfiliadoEmisor?: string;
  nombreCongreso?: string;
  fechaCongreso?: string;
  sedeCongreso?: string;
  numeroEntrada?: string;
}

export interface AceptarEntradaPayload {
  token: string;
  nombrePortador: string;
  apellidoPortador: string;
  dniPortador: string;
  emailPortador: string;
}

export interface AceptarEntradaResponse {
  exitoso: boolean;
  mensaje: string;
  idEntradaDetalle?: number;
  numeroEntrada?: string;
}

export const autogestionService = {
  getHomeWidget: async (): Promise<HomeWidgetResponse> => {
    try {
      const response = await axios.get(`${API_URL}/api/public/congresos/home-widget`);
      return response.data;
    } catch (error: any) {
      throw error.response ? error.response.data : new Error(error.message);
    }
  },

  generarLinkTransferencia: async (idEntradaDetalle: number, idAfiliadoEmisor: number): Promise<GenerarLinkResponse> => {
    try {
      const response = await axios.post(`${API_URL}/api/congresos/entradas/${idEntradaDetalle}/generar-link-transferencia?idAfiliadoEmisor=${idAfiliadoEmisor}`);
      return response.data;
    } catch (error: any) {
      throw error.response ? error.response.data : new Error(error.message);
    }
  },

  getInfoLinkTransferencia: async (token: string): Promise<InfoLinkTransferencia> => {
    try {
      const response = await axios.get(`${API_URL}/api/congresos/entradas/transferencia/${encodeURIComponent(token)}/info`);
      return response.data;
    } catch (error: any) {
      throw error.response ? error.response.data : new Error(error.message);
    }
  },

  aceptarEntradaTransferida: async (payload: AceptarEntradaPayload): Promise<AceptarEntradaResponse> => {
    try {
      const response = await axios.post(`${API_URL}/api/congresos/entradas/transferencia/${encodeURIComponent(payload.token)}/aceptar`, payload);
      return response.data;
    } catch (error: any) {
      throw error.response ? error.response.data : new Error(error.message);
    }
  }
};

export default autogestionService;
